import { Config } from "@amtana/module";
import { z } from "zod";

// Review group 2, decision h: the scheduled purge task (S6.08, reoriented by ADR-026 point 3,
// epic 30, S30.01) moved here from auth, which it no longer touches at all (every row it once
// purged directly is now each module's own erase-step reaction, ADR-026's own "What changes"
// table). `purgeIntervalMs` moves with it, off AUTH_PURGE_INTERVAL_MS and onto this module's own
// env var; a deploy that still sets the old one simply falls back to the same default.

/** The self-service grace period the Danger Zone, the request email and the retention page promise
 * (ADR-026 point 2): fourteen days. */
export const DELETION_GRACE_MS = 14 * 24 * 60 * 60 * 1000;

export const accountConfig = Config.define((c) => ({
  /** How often the scheduled purge task checks for a self-service account whose deletion grace
   * period has elapsed. */
  purgeIntervalMs: c.env("ACCOUNT_PURGE_INTERVAL_MS", z.coerce.number().int().min(1000).default(60_000)),
  /** How long a self-service erasure waits before it is final (D929). Shorter only outside
   * production, to watch a whole erasure run on a local stack; production refuses anything under
   * what every screen and email promises. */
  deletionGraceMs: c.env(
    "ACCOUNT_DELETION_GRACE_MS",
    z.coerce.number().int().min(60_000).default(DELETION_GRACE_MS),
    {
      refuseInProduction: (value) =>
        value < DELETION_GRACE_MS
          ? "is shorter than the fourteen days every screen and email promises"
          : undefined,
    },
  ),
}));
